import { dateService } from '../../../services/date';

const required = dependentField => {
  return {
    validatorFn: (value, formValues) => {
      const isValueBlank = val => {
        if (typeof val === 'undefined' || val === null) return true;

        if (typeof val === 'string' || Array.isArray(val)) {
          if (val.length === 0) {
            return true;
          }
        }

        return false;
      };

      if (dependentField && isValueBlank(formValues[dependentField])) {
        return true;
      }

      return !isValueBlank(value);
    },
    errorMessage: 'Field is Required',
  };
};

const dateRange = endDateField => {
  return {
    validatorFn: (value, formValues) => {
      const endDateValue = formValues[endDateField];

      if (
        typeof value === 'undefined' ||
        value === null ||
        typeof endDateValue === 'undefined' ||
        endDateValue === null
      ) {
        return true;
      }

      if (dateService.compareDates(value, endDateValue) > 0) {
        return false;
      }

      return true;
    },
    errorMessage: 'Invalid',
  };
};

const min = minValue => {
  return {
    validatorFn: value => {
      if (typeof value === 'undefined' || value === null) return true;

      if (parseFloat(value) < minValue) {
        return false;
      }

      return true;
    },
    errorMessage: `Value must be above ${minValue}`,
  };
};

const max = maxValue => {
  return {
    validatorFn: value => {
      if (typeof value === 'undefined' || value === null) return true;

      if (parseFloat(value) > maxValue) {
        return false;
      }

      return true;
    },
    errorMessage: `Value must be below ${maxValue}`,
  };
};

//  Validator that enforces max only if a certain other field matches a value.
//  Will look into making this functionality a generic wrapper function.
const conditionalMax = (dependentField, dependentValue, maxValue) => {
  return {
    validatorFn: (value, formValues) => {
      if (typeof value === 'undefined' || value === null) return true;

      if (formValues[dependentField] !== dependentValue) {
        return true;
      }

      if (parseFloat(value) > maxValue) {
        return false;
      }

      return true;
    },
    errorMessage: `Value must be below ${maxValue}`,
  };
};

const maxLength = length => {
  return {
    validatorFn: value => {
      if (typeof value === 'undefined' || value === null) return true;

      return value.length <= length;
    },
    errorMessage: `String length must be less than ${length} characters`,
  };
};

const regexMatch = regex => {
  return {
    validatorFn: value => {
      if (typeof value === 'undefined' || value === null || value === '') return true;

      return value.match(regex);
    },
    errorMessage: `String does not match the required format`,
  };
};

export { required, dateRange, min, max, maxLength, regexMatch, conditionalMax };
